import { useTranslation } from 'react-i18next'
import { useMaintenance } from '../contexts/MaintenanceContext'
import './MaintenanceBanner.scss'

const MaintenanceBanner = () => {
  const { t } = useTranslation('platform')
  const { isMaintenanceMode } = useMaintenance()

  if (!isMaintenanceMode) {
    return null
  }

  return (
    <div className="maintenance-banner">
      <span className="maintenance-banner__icon">&#x1F527;</span>
      <span className="maintenance-banner__text">
        {t('maintenance.bannerMessage')}
      </span>
    </div>
  )
}

export default MaintenanceBanner
